import { useParams, Navigate } from "react-router-dom";
import { useGetSingleGif } from "../api/queries";
import GallerySpinner from "containers/GalleryPage/Components/GallerySpinner";

const MoveRedirect = () => {
  const { id } = useParams();
  const { data: gifData, isLoading, isError } = useGetSingleGif(id);

  if (isLoading) {
    return (
      <div className="bg-black h-screen w-screen">
        <GallerySpinner />
      </div>
    );
  }

  if (isError || !gifData?.channel?.slug) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/ch/${gifData.channel.slug}/${id}`} replace />;
};

export default MoveRedirect;
